// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00ce6350","239":"25d80104","455":"90df939a","457":"9d4e6b21","851":"c2809901"}[chunkId] + ".chunk.js";
};